import * as React from "react";
import { Link } from "react-router-dom";

export interface RouteOrActionProps {
    isRoute: boolean;
    route: string;
    action: () => void;
}

export default class RouteOrAction extends React.PureComponent<
    RouteOrActionProps,
    {}
> {
    public render() {
        if (this.props.isRoute) {
            return <Link to={this.props.route}>{this.props.children}</Link>;
        } else {
            return <a onClick={this.props.action}>{this.props.children}</a>;
        }
    }
}
